import Comm from './comm';
let constants = {
    STORAGE_KEY_SIDEBAR_STATUS: 'sidebarStatus',
    WIN_LOGIN: 'login',
    HOME_PAGE_LOGIN: '/#/',
    MENU_NAME: 'kd-kiaf-menu',

    CODE_EMPTY_JWT_TOKEN: 'NULL',
    CODE_FULLSCREEN_PAGE: 'fullscreenPage',
    CODE_BROADCAST_CHANNEL_VERSION: 55,
    KIAF_MENU_HOME_URL: '/kiaf/menuhome',
    KIAF_MENU_HOME_TITLE: '首页',
    KIAF_URL_APP_PORTAL: 'kiaf_app_portal',
    THEME: 'light',
    THEME_DEFAULT: 'light',
    CRX_EVENT_OPEN_WINDOWS: 'openWindows',
    CRX_EVENT_SWITCH_SCREEN: 'switchScreen',
    CRX_EVENT_SWITCH_WINDOWS: 'windowSwitch',
    CRX_EVENT_CLOSE_TAB: 'closeTab',
    CRX_EVENT_GET_SCREENS: 'getScreens',
    CRX_EVENT_SPLIT_SCREEN: 'splitScreen',
    CRX_EVENT_OPEN_LINK: 'openLink',

    EVENT_BUS_CODE_CLOSE_ALL_WIN: 'KIAF_EVENT_BUS_CODE_CLOSE_ALL_WIN',
    EVENT_BUS_CODE_CLOSE_LOGIN_WIN: 'KIAF_EVENT_BUS_CODE_CLOSE_LOGIN_WIN',
    EVENT_BUS_CODE_PRELOAD_CLOSE_LOGIN_WIN: 'KIAF_EVENT_BUS_CODE_PRELOAD_CLOSE_LOGIN_WIN',
    EVENT_BUS_CODE_CHECK_LOGINED: 'KIAF_EVENT_BUS_CODE_CHECK_LOGINED',
    EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK: 'KIAF_EVENT_BUS_CODE_CHECK_LOGINED_CALLBACK',
    EVENT_BUS_CODE_CHANGE_THEME: 'KIAF_EVENT_BUS_CODE_CHANGE_THEME',
    EVENT_BUS_CODE_REFRESH_MESSAGE_CENTER: 'KIAF_EVENT_BUS_CODE_REFRESH_MESSAGE_CENTER',
    EVENT_BUS_CODE_LOGOUT: 'KIAF_EVENT_BUS_CODE_LOGOUT',
    EVENT_BUS_CODE_ADDTAG: 'KIAF_EVENT_BUS_CODE_ADDTAG',
    EVENT_BUS_CODE_PARENT_ADDTAG: 'KIAF_EVENT_BUS_CODE_PARENT_ADDTAG',
    EVENT_BUS_CODE_MEDIA_DOWNLOAD: 'KIAF_EVENT_BUS_CODE_MEDIA_DOWNLOAD',
    EVENT_BUS_CODE_REMOVE_TAG: 'KIAF_EVENT_BUS_CODE_REMOVE_TAG',
    EVENT_BUS_CODE_OPEN_EXTERNAL_WEBVIEW: 'KIAF_EVENT_BUS_CODE_OPEN_EXTERNAL_WEBVIEW',
    EVENT_BUS_CODE_OPEN_INTERNAL_WEBVIEW: 'KIAF_EVENT_BUS_CODE_OPEN_INTERNAL_WEBVIEW',
    EVENT_BUS_CODE_NEXT_ROUTE: 'KIAF_EVENT_BUS_CODE_NEXT_ROUTE',
    EVENT_BUS_CODE_START_HEARTBEAT: 'KIAF_EVENT_BUS_CODE_START_HEARTBEAT',
    EVENT_BUS_CODE_STOP_HEARTBEAT: 'KIAF_EVENT_BUS_CODE_STOP_HEARTBEAT',
    EVENT_BUS_CODE_APP_CLOSED_APP: 'KIAF_EVENT_BUS_CODE_APP_CLOSED_APP',
    EVENT_BUS_CODE_APP_PORTAL_CLOSE_ALL_WIN: 'APP_PORTAL_CLOSE_ALL_WIN',
    EVENT_BUS_CODE_APP_PORTAL_OPEN_APP: 'APP_PORTAL_OPEN_APP',
    // EVENT_BUS_CODE_APP_PORTAL_CHECK_APP_ISOPENED: 'APP_PORTAL_CHECK_APP_IS_OPENED',
    EVENT_BUS_CODE_APP_PORTAL_CLOSED_APP: 'APP_PORTAL_CLOSED_APP',
    EVENT_BUS_CODE_APP_PORTAL_RESPONSE_APP_LIST: 'APP_PORTAL_RESPONSE_APP_LIST',
    EVENT_BUS_CODE_SWITCH_WINDOW: 'KIAF_EVENT_BUS_CODE_SWITCH_WINDOW',
    EVENT_BUS_CODE_OPEN_FULLSCREEN_WINDOW: 'KIAF_EVENT_BUS_CODE_OPEN_FULLSCREEN_WINDOW',
    EVENT_BUS_CODE_CLOSE_FULLSCREEN_WINDOW: 'KIAF_EVENT_BUS_CODE_CLOSE_FULLSCREEN_WINDOW',
    EVENT_BUS_CODE_MENU_ITEM_CLICK: 'KIAF_EVENT_BUS_CODE_MENU_ITEM_CLICK',
    EVENT_BUS_CODE_CLOSE_EXTERNAL_WEBVIEW: 'KIAF_EVENT_BUS_CODE_CLOSE_EXTERNAL_WEBVIEW',
    EVENT_BUS_CODE_PARENT_SWITCH_WINDOW: 'KIAF_EVENT_BUS_CODE_PARENT_SWITCH_WINDOW',
    EVENT_BUS_CODE_ACTIVE_MENU: 'KIAF_EVENT_BUS_CODE_ACTIVE_MENU',
    EVENT_BUS_CODE_SELECT_MENU: 'KIAF_EVENT_BUS_CODE_SELECT_MENU',
    EVENT_BUS_CODE_REMOVE_TAGVIEW: 'KIAF_EVENT_BUS_CODE_REMOVE_TAGVIEW',
    EVENT_BUS_CODE_ONLINENUMBER: 'KIAF_EVENT_BUS_CODE_ONLINENUMBER',
    EVENT_BUS_CODE_WEBVIEW_ONLOAD: 'KIAF_EVENT_BUS_CODE_WEBVIEW_ONLOAD',
    EVENT_BUS_CODE_KEEP_SESSION_ACTIVE: 'KIAF_EVENT_BUS_CODE_KEEP_SESSION_ACTIVE',

    STORAGE_KEY_THEME: Comm.getAppName() + '_THEME',
    STORAGE_KEY_USER_INFO: Comm.getAppName() + '_STORAGE_KEY_USER_INFO',
    STORAGE_KEY_TEMP_JWT_TOKEN: Comm.getAppName() + '_STORAGE_KEY_TEMP_JWT_TOKEN', //用于刷新时缓存到sessionStorage
    STORAGE_KEY_TEMP_REFRESH_TOKEN: Comm.getAppName() + '_STORAGE_KEY_TEMP_REFRESH_TOKEN', //用于刷新时缓存到sessionStorage
    STORAGE_KEY_JWT_TOKEN: Comm.getAppName() + '_STORAGE_KEY_JWT_TOKEN',
    STORAGE_KEY_REFRESH_TOKEN: Comm.getAppName() + '_STORAGE_KEY_REFRESH_TOKEN',
    STORAGE_KEY_REMEMBER_ME: Comm.getAppName() + '_STORAGE_KEY_REMEMBER_ME',
    STORAGE_KEY_WINDOWS: Comm.getAppName() + '_STORAGE_KEY_WINDOWS',
    STORAGE_KEY_SUBWINDOWS: Comm.getAppName() + '_STORAGE_KEY_SUBWINDOWS',
    STORAGE_KEY_WEBVIEW_MODE: Comm.getAppName() + '_STORAGE_KEY_WEBVIEW_MODE',
    STORAGE_KEY_WEBVIEW_PAGE: Comm.getAppName() + '_STORAGE_KEY_WEBVIEW_PAGE',
    STORAGE_KEY_CUSTOM_CONFIG: Comm.getAppName() + '_STORAGE_KEY_CUSTOM_CONFIG',
    STORAGE_KEY_MENULIST: Comm.getAppName() + '_STORAGE_KEY_MENULIST',
    STORAGE_KEY_FIRST_LOAD: Comm.getAppName() + '_STORAGE_KEY_FIRST_LOAD',
    STORAGE_KEY_HEART_BEAT_TRIGGER: Comm.getAppName() + '_STORAGE_KEY_HEART_BEAT_TRIGGER',
    STORAGE_KEY_CHROME_EXT_WIN: Comm.getAppName() + '_STORAGE_KEY_CHROME_EXT_WIN',
    STORAGE_KEY_PRELOAD_MODE: Comm.getAppName() + '_STORAGE_KEY_PRELOAD_MODE',
    STORAGE_KEY_PARENT_APP_HOST: Comm.getAppName() + '_STORAGE_KEY_PARENT_APP_HOST',
    STORAGE_KEY_STORAGE: Comm.getAppName() + '_STORAGE_KEY_STORAGE',
    STORAGE_KEY_STORAGE_CROSS_APP: 'CROSS_APP_STORAGE_KEY_STORAGE',
    STORAGE_KEY_SCREEN_COUNT: Comm.getAppName() + '_STORAGE_KEY_SCREEN_COUNT',
    STORAGE_KEY_POPUP_WINDOW: Comm.getAppName() + '_STORAGE_KEY_POPUP_WINDOW',
    STORAGE_KEY_SUBWINDOW: Comm.getAppName() + '_STORAGE_KEY_SUBWINDOW',
    STORAGE_KEY_MAP_CENTER_POINT: Comm.getAppName() + '_STORAGE_KEY_MAP_CENTER_POINT',
    STORAGE_KEY_USER: Comm.getAppName() + '_STORAGE_KEY_USER',
    STORAGE_KEY_CHANNEL_CODE: Comm.getAppName() + '_STORAGE_KEY_CHANNEL_CODE',
    STORAGE_KEY_APP_PORTAL_TARGET: Comm.getAppName() + '_STORAGE_KEY_APP_PORTAL_TARGET',
    STORAGE_KEY_MENU_BAR_MODE: Comm.getAppName() + '_STORAGE_KEY_MENU_BAR_MODE',
    STORAGE_KEY_MENU_HOME_URL: Comm.getAppName() + '_STORAGE_KEY_MENU_HOME_URL',
    STORAGE_KEY_HIDE_MENU: Comm.getAppName() + '_STORAGE_KEY_HIDE_MENU',
    STORAGE_KEY_APP_PORTAL_ID: Comm.getAppName() + '_STORAGE_KEY_APP_PORTAL_ID',
    STORAGE_KEY_LATEST_PAGE: Comm.getAppName() + '_STORAGE_KEY_LATEST_PAGE',
    STORAGE_KEY_WINDOWID: Comm.getAppName() + '_STORAGE_KEY_WINDOWID',
    STORAGE_KEY_USER_ONLINE: Comm.getAppName() + '_STORAGE_KEY_USER_ONLINE',
    STORAGE_KEY_LAST_ACTIVE_ID: Comm.getAppName() + '_STORAGE_KEY_LAST_ACTIVE_ID',
    STORAGE_KEY_LAST_ACTIVE_TAG: Comm.getAppName() + '_STORAGE_KEY_LAST_ACTIVE_TAG',
    STORAGE_KEY_LAST_INTERNAL_MENU: Comm.getAppName() + '_STORAGE_KEY_LAST_INTERNAL_MENU',
    STORAGE_KEY_DOWNLOAD_FILES: Comm.getAppName() + '_STORAGE_KEY_DOWNLOAD_FILES',
    STORAGE_KEY_CANCELED_DOWNLOAD_FILES: Comm.getAppName() + '_STORAGE_KEY_CANCELED_DOWNLOAD_FILES',
    STORAGE_KEY_LAST_MOUSEMOVE_TIME: Comm.getAppName() + '_STORAGE_KEY_LAST_MOUSEMOVE_TIME',
    STORAGE_KEY_DOCUMENT_TITLE: Comm.getAppName() + '_STORAGE_KEY_DOCUMENT_TITLE',
    STORAGE_KEY_SPA: Comm.getAppName() + '_STORAGE_KEY_SPA',
    STORAGE_KEY_REDIRECT_URL: Comm.getAppName() + '_STORAGE_KEY_REDIRECT_URL',

    CUSTOM_API_KEY_LOGIN: 'KIAF_LOGIN',
    CUSTOM_API_KEY_LOGOUT: 'KIAF_LOGOUT',
    CUSTOM_API_KEY_AUTHORITY_ME: 'KIAF_AUTHORITY_ME',
    CUSTOM_API_KEY_GET_SYSTEM_HOMEPAGE: 'KIAF_GET_SYSTEM_HOMEPAGE',
    CUSTOM_API_KEY_GET_MENU: 'KIAF_GET_MENU',
    CUSTOM_API_KEY_CHANGE_PASSWORD: 'KIAF_CHANGE_PASSWORD',
    CUSTOM_API_KEY_UPDATE_SYSTEM_HOMEPAGE: 'KIAF_UPDATE_SYSTEM_HOMEPAGE',
    CUSTOM_API_KEY_GET_IP_ADDR: 'KIAF_GET_IP_ADDR',
    CUSTOM_API_KEY_GET_WATERMARK_INFO: 'KIAF_GET_WATERMARK_INFO',
    CUSTOM_API_KEY_GET_EXPIRED_DATETIME: 'KIAF_GET_EXPIRED_DATETIME',
    CUSTOM_API_KEY_HEARTBEAT: 'KIAF_HEARTBEAT',
    CUSTOM_API_KEY_MAP_CENTER_POINT: 'CUSTOM_API_KEY_MAP_CENTER_POINT'
};
export default constants;
